import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GuideBanner } from "../header/GuideBanner";
import { CategoryMenuGrid } from "./CategoryMenuGrid";
/** 그리드 섹션 스켈레톤 - CategoryMenuGrid와 동일한 레이아웃 */ const EditionCategoryGridSkeleton = ()=>/*#__PURE__*/ _jsxs("section", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "hidden h-6 w-40 animate-pulse rounded bg-gray-200 sm:block"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "h-5 w-28 animate-pulse rounded bg-gray-200 sm:hidden"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "hidden h-12 w-full animate-pulse rounded-md bg-gray-100 sm:block"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "animate-pulse overflow-hidden rounded-md border border-gray-200 sm:hidden",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "grid grid-cols-3",
                    children: Array.from({
                        length: 6
                    }).map((_, index)=>/*#__PURE__*/ _jsx("div", {
                            className: "flex items-center justify-center border-gray-100 px-1 py-3 ".concat((index + 1) % 3 !== 0 ? "border-r" : "", " ").concat(index < 3 ? "border-b" : ""),
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "h-4 w-12 rounded bg-gray-200"
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "hidden animate-pulse overflow-hidden rounded-md border border-gray-200 sm:block",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex",
                    children: Array.from({
                        length: 4
                    }).map((_, colIndex)=>/*#__PURE__*/ _jsxs("div", {
                            className: "h-[220px] min-w-0 flex-1 border-b border-gray-100 py-2.5 sm:min-w-[180px] ".concat(colIndex < 3 ? "border-r" : "", " ").concat(colIndex >= 3 ? "hidden xl:block" : ""),
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "px-4 py-2",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "h-5 w-20 rounded bg-gray-200"
                                    })
                                }),
                                Array.from({
                                    length: 4
                                }).map((_, itemIndex)=>/*#__PURE__*/ _jsx("div", {
                                        className: "px-4 py-2",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "h-4 w-16 rounded bg-gray-100"
                                        })
                                    }, itemIndex))
                            ]
                        }, colIndex))
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "hidden h-10 w-full animate-pulse rounded-md bg-gray-100 sm:block"
            })
        ]
    });
export const EditionCategoryGridSection = (param)=>{
    let { selectedCategoryId , isLastDepthByTree , lnbItems , directChildCategories , onCategorySelect , getCategoryHref , categoryInfo , isLoading , isFirstDepth  } = param;
    // 로딩 중이면 스켈레톤 표시
    if (isLoading) {
        return /*#__PURE__*/ _jsx(EditionCategoryGridSkeleton, {});
    }
    // 가이드 배너 렌더링
    const renderGuideBanner = ()=>{
        if (!(categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.guideBanner) || !categoryInfo.guideBannerText) return undefined;
        return /*#__PURE__*/ _jsx(GuideBanner, {
            text: categoryInfo.guideBannerText,
            href: categoryInfo.guideBannerUrl || undefined
        });
    };
    // 1depth: 전체 카테고리
    if (isFirstDepth) {
        return /*#__PURE__*/ _jsx(CategoryMenuGrid, {
            title: "전체 리스트",
            items: lnbItems,
            selectedCategoryId: selectedCategoryId,
            onCategorySelect: onCategorySelect,
            getCategoryHref: getCategoryHref,
            expandable: true,
            defaultExpanded: false,
            guideBanner: renderGuideBanner()
        });
    }
    // 중간 depth: 하위 카테고리
    if (!isLastDepthByTree && directChildCategories.length > 0) {
        return /*#__PURE__*/ _jsx(CategoryMenuGrid, {
            title: "더 자세히 찾기",
            items: directChildCategories,
            onCategorySelect: onCategorySelect,
            getCategoryHref: getCategoryHref,
            variant: "titleOnly"
        });
    }
    // 마지막 depth: 표시 안함
    return null;
};
